// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","966":"dashboard"}[chunkId] + "." + {"443":"5b060bf2","966":"ad4ae7f6"}[chunkId] + ".js";
};